import React from 'react';
//import nazarethVideo from './assets/Nazareth/Nazareth.mp4';
import './Clientes-Modal.css'; // Asegúrate de que este CSS contenga los estilos mejorados
//import estructura from './assets/Nazareth/est-naz.png';
//import plataforma from './assets/Nazareth/estr-na.jpeg';
//import escalerilla from './assets/Nazareth/estructura na.jpeg'; // Renombrado a minúscula para consistencia
import Video from './assets/Nazareth/Video.mp4'

const Nazareth = () => {
  return (
    <div className="container">
      <h2>
        ✅ Proyecto: Casa de Ejercicios de Nazareth🌞✨{' '}
      </h2>
       <video controls>
              <source src={Video} type="video/mp4" />
              Tu navegador no soporta la reproducción de video.
            </video>
      <p>
       

<span className="highlight">Energía renovable al servicio de la espiritualidad: este espacio emblemático ahora combina reflexión, sostenibilidad y eficiencia energética.</span>

<br/><br/>En la Casa de Ejercicios de Nazareth, uno de los lugares más representativos de Pamplona y visible desde gran parte de la ciudad, instalamos un sistema solar fotovoltaico conectado a la red con una capacidad de 22.16 kWp, conformado por 56 paneles solares de alta eficiencia y un inversor multicanal de 30 kW.
<br/><br/>Esta tecnología permite gestionar grandes cargas energéticas con estabilidad, optimizando el rendimiento del sistema y garantizando un flujo de energía seguro y continuo para las actividades del establecimiento. <br/>

<br/>Los objetivos de este proyecto fueron:<br/><br/>

✔ Reducir de manera significativa los costos asociados al consumo eléctrico<br/>
✔ Implementar una solución sostenible, alineada con el compromiso ambiental de la institución con la fé y el medio ambiente.<br/>
✔ Garantizar energía continua para las actividades de hospedaje y servicios ofrecidos durante los retiros espirituales<br/>

<br/>Hoy, la Casa de Ejercicios de Nazareth produce su energía diaria, reduciendo el valor mensual de su factura eléctrica y permitiendo que esos recursos se destinen a fortalecer la infraestructura y la experiencia de quienes visitan el lugar.
<br/><br/>Además, esta instalación contribuye directamente a la reducción de emisiones de CO₂, convirtiendo este espacio de espiritualidad y encuentro en un referente de sostenibilidad en la región.<br/>

<br/><span className="highlight">Este proyecto cuenta con el acompañamiento de IPSUM Ingeniería e Innovación, ofreciendo:</span> <br/>

<br/>🔧Soporte técnico y mantenimiento preventivo<br/>
🔧Monitoreo de la producción energética para garantizar máxima eficiencia<br/>
🔧Instalación estructural segura, diseñada para prolongar la vida útil del sistema<br/>
🔧Capacitación al usuario en el uso de la plataforma de monitoreo<br/>
🔧Acompañamiento presencial de nuestros ingenieros durante y después de la instalación<br/>
<br/>
 <div className="video-responsive">
        <iframe
          src="https://www.youtube.com/embed/e_VWwl238i8"
          title="Testimmonio Casa de Nazareth"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
<br/>

<span className="highlight">Una decisión inteligente que une ahorro, sostenibilidad y propósito.</span> <br/>
      </p>

     
    </div>
  );
};

export default Nazareth;
